<template>
  <PumpsCollectionPage />
</template>

<script setup lang="ts">
import PumpsCollectionPage from './index.vue'
</script>
